module.exports = __webpack_public_path__ + "img/Realisme_Tanker_i_tida4.7a4db147.jpg";